import { render, staticRenderFns } from "./StockListesiButonsCellRenderer.vue?vue&type=template&id=12f2cb10"
import script from "./StockListesiButonsCellRenderer.vue?vue&type=script&lang=js"
export * from "./StockListesiButonsCellRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports